/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import { View } from 'backbone.marionette';

import InputCollectionView from './InputCollectionView';
import tmplInputListView from './InputListView.hbs';

const InputListView = View.extend({
  template: tmplInputListView,

  className: 'input-list-view',

  ui: {
    emptyTextMessage: '.empty-text-message',
    inputCollectionContainer: '.input-collection-container'
  },

  regions: {
    inputCollectionContainer: '@ui.inputCollectionContainer'
  },

  events: {
    'click .add-input': 'addInput'
  },

  onRender() {
    this.inputCollection = new InputCollectionView({
      model: this.model,
      collection: this.collection
    });
    this.showChildView('inputCollectionContainer', this.inputCollection);
  },

  addInput(e) {
    e.preventDefault();
    this.getChildView('inputCollectionContainer').options.collection.add({});
  },

  getFormData() {
    return this.inputCollection.getFormData();
  }
});

export default InputListView;
